module.exports = __webpack_public_path__ + "assets/icon-nps-heart.54b308c5.svg";